import { Button } from '@ads/components-react';
import * as Dialog from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';

export interface DeleteStateModalProps {
  readonly open: boolean;
  /** Nome do estado a excluir, interpolado na mensagem de confirmação. */
  readonly stateName: string;
  readonly onConfirm: () => void;
  readonly onOpenChange: (open: boolean) => void;
}

/**
 * Modal de confirmação de exclusão de Estado (Radix Dialog). Controlado por
 * `open`/`onOpenChange`; ao confirmar dispara `onConfirm`. Fiel ao frame
 * *Estados — Modal: Excluir* de `design/location.pen`.
 */
export function DeleteStateModal({
  open,
  stateName,
  onConfirm,
  onOpenChange,
}: DeleteStateModalProps) {
  const { t } = useTranslation('location');

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-none z-50 h-screen w-screen bg-base-gray-900 bg-opacity-medium backdrop-blur-soft" />
        <Dialog.Content
          aria-describedby={undefined}
          className="-translate-x-1/2 -translate-y-1/2 fixed top-1/2 left-1/2 z-50 flex w-full max-w-[26rem] flex-col gap-mini rounded-lg bg-ctx-layout-surface p-xxs shadow-level4 focus:outline-none"
        >
          <Dialog.Title className="text-ctx-content-title ts-heading-xs">
            {t('states.delete.title')}
          </Dialog.Title>
          <p className="text-ctx-content-base ts-paragraph-xs">
            {t('states.delete.body', { name: stateName })}
          </p>
          <div className="flex justify-end gap-nano">
            <Dialog.Close asChild>
              <Button hierarchy="secondary" size="md">
                {t('states.delete.cancel')}
              </Button>
            </Dialog.Close>
            <Button hierarchy="danger" size="md" onClick={onConfirm}>
              {t('states.delete.confirm')}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
